export default "__VITE_ASSET__ZV_KRlNG__"